import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate } from "react-router-dom";
import "./Datatable.css";
import Swal from "sweetalert2";
import "font-awesome/css/font-awesome.min.css";
import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};

const AccountDelRequestTable = () => {
  const [form2Events, setForm2Events] = useState([]);
  const [alert, setAlert] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchItem, setSearchItem] = useState("");
  const [itemsPerPage] = useState(10);
  const [totalCareers, setTotalCareers] = useState(0);

  const navigate = useNavigate();

  const handleClick = (email) => {
    Swal.fire({
      title: "Job Details",
      html: `
        <p class="confimrmodel">Are you sure you want to delete?</p>
        <p>${email}</p>
        <p class="warnmodel">
          <i class="fa fa-exclamation-triangle" style="font-size: 18px; color: #d33; margin-right: 8px;"></i>
          <span>You cannot recover the data after deleting.</span>
        </p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(email); // use email instead of id
      }
    });
  };
  

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (page = 1, searchQuery = "") => {
    try {
      const response2 = await axios.get(
        `https://www.hrmsapi.ktig.org.in/api/get-all/del-request`
      );
      // console.log(response2,"response2>>")
      setForm2Events(response2.data.AccountDelRequests);
      setTotalCareers(response2.data.totalRequests);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, searchItem);
  }, [currentPage, searchItem]);

  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
    debouncedSearch(e.target.value);
  };

  const handleDelete = async (email) => {
    try {
      await axios.post(
        "https://www.hrmsapi.ktig.org.in/api//update-profile-inactive",
        { employee_email: email },
        { headers: { "Content-Type": "application/json" } }
      );
  
      setForm2Events((prevEvents) =>
        prevEvents.filter((event) => event.employee_email !== email)
      );
  
      toast.success("Account deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      toast.error("Failed to delete account.", {
        position: "top-right",
        autoClose: 3000,
      });
      console.error("Delete error:", error);
    }
  };
  
  const debouncedSearch = useCallback(
    debounce((query) => {
      fetchData(1, query);
      setCurrentPage(1);
    }, 500),
    [fetchData]
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil(totalCareers / itemsPerPage);

  const paginatedData = form2Events.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="custom-table-container wow fadeInUp" data-wow-delay="0.2s">
      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div className="breadcrumb-title pe-3">
          <ToastContainer />

          <h5>Account Del User Details</h5>
          {alert && (
            <CustomAlert
              message={alert.message}
              onClose={() => setAlert(null)}
              type={alert.type}
            />
          )}
        </div>
      </div>

      <table className="custom-data-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Email</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {form2Events.map((item, index) => (
            <tr key={item._id}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>{item.employee_email}</td>
              <td className="status_wrap">
                
                <button
                  className="custom-btn-delete"
                  onClick={() => handleClick(item.employee_email)}
                >
                  <i className="fa fa-trash" style={{ color: "white" }}></i> {}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </button>

        {/* Generate page numbers dynamically */}
        {Array.from({ length: 7 }).map((_, index) => {
          // Calculate the actual page number to display
          const pageNumber =
            currentPage <= 6 ? index + 1 : currentPage + index - 2;

          // Ensure pageNumber doesn't exceed totalPages and is greater than 0
          if (pageNumber < 1 || pageNumber > totalPages) {
            return null; // Skip invalid page numbers
          }

          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={currentPage === pageNumber ? "active" : ""}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default AccountDelRequestTable;
